import {RequestModel} from "../../../request";
import {REQUEST} from "../../../requests.consts";
import {shareState} from "../../../../../app/share-state";

export class PostRequestKickGroupModel extends RequestModel {
  groupId: Number;
  otherUserId: Number;

  constructor(groupId, otherUserId) {
    super(REQUEST.CATEGORY.groups, REQUEST.ACTION.GROUPS.kick, {}, true, false, true, true);

    this.apiEnvironment = shareState.environment.baseUrl;
    this.method = REQUEST.METHOD_TYPE.post;
    this.groupId = groupId;
    this.otherUserId = otherUserId;
  }

  get body() {
    const lang = {"lang": shareState.language.id}
    const groupId = this.groupId ? {'groupID': this.groupId} : {}
    const otherUserId = this.otherUserId ? {'kickedID': this.otherUserId} : {}

    return {...groupId, ...otherUserId, ...lang};
  }
}
